import { useApi } from '@/composables/useApi'

const api = useApi()
const defaultCallAction = {
  id: null,
  id_vsl: null,
  type: 'inner_button',
  text: '',
  link: '',
  size: 'md',
  position: 'cc',
  button_target: '_blank',
  button_color: '#000000',
  text_color: '#ffffff',
  text_hover_color: '#737070',
  background_color: '#a40404',
  background_hover_color: 'rgba(255, 122, 122, 1)',
  start: 0,
  end: 0,
  index_off_save: null,
  transparencia_btn: 10,
}

export default {
  namespaced: true,
  state: {
    callAction: {
      ...defaultCallAction,
    },
    allCallActions: [],
    callActions_off_save: [],
  },
  getters: {
    callAction: state => state.callAction,
    allCallActions: state => state.allCallActions,
    isSave: state => state.callActions_off_save.length > 0,
    getOpacityBtn: state => (state.callAction.transparencia_btn === 10 ? 1 : parseFloat(`0.${state.callAction.transparencia_btn}`)),
    GET_CALL_ACTION_OFF_SAVE: state => state.callActions_off_save,
  },
  mutations: {
    SET_CALL_ACTION(state, payload) {
      state.callAction = payload
    },
    SET_ID_VLS(state, payload) {
      state.callAction.id_vsl = payload
    },
    SET_ALL_CALL_ACTIONS(state, payload) {
      state.allCallActions = payload
    },
    SET_CONVERT_TIME_END_START(state, payload) {
      state.callActions_off_save = payload
    },
    SET_CALL_ACTIONS_OFF_SAVE(state) {
      if (state.callAction.index_off_save === undefined) {
        state.callAction.index_off_save = state.callActions_off_save.length
      }
      const index = state.callActions_off_save.findIndex(
        item => item.index_off_save === state.callAction.index_off_save,
      )
      if (index !== -1) {
        state.callActions_off_save[index] = state.callAction
        state.allCallActions[index] = state.callAction
      } else {
        state.callActions_off_save.push(state.callAction)
        if (state.callAction.id === null) {
          state.allCallActions.push(state.callAction)
        }
      }
    },
    CLEAR_SAVE_OFF(state) {
      state.callActions_off_save = []
    },
  },
  actions: {
    async fetchCallActions({ commit }, idVsl) {
      const response = await api.get(`/call-actions/vsl/${idVsl}`)
      commit('SET_ALL_CALL_ACTIONS', response.data)
    },
    async deletedCallAction({ state, dispatch, commit }) {
      await api.delete(`/call-actions/${state.callAction.id}`)
      await dispatch('fetchCallActions', state.callAction.id_vsl)
      commit('SET_CALL_ACTION', {})
    },
    async createVariosCallActions({ state, dispatch, commit }, duration) {
      state.callActions_off_save.forEach(c => c.end === 'Infinito' && (c.end = dispatch('convertTimeToSeconds', duration)))
      await api.post('/call-actions/varias', state.callActions_off_save)
      commit('CLEAR_SAVE_OFF')
    },
    resetCallAction({ commit }) {
      commit('SET_CALL_ACTION', JSON.parse(JSON.stringify(defaultCallAction)))
    },
    resetCallActionOffSave({ state, commit }) {
      const index = state.callActions_off_save.findIndex(item => {
        if (item.index_off_save === state.callAction.index_off_save) {
          return true
        }
      })
      if (index !== -1) {
        state.callActions_off_save.splice(index, 1)
      }
      commit('SET_CALL_ACTION', JSON.parse(JSON.stringify(defaultCallAction)))
    },
  },
}
